import { Component, OnInit, ChangeDetectionStrategy, ViewChild, ChangeDetectorRef, OnDestroy, AfterViewInit } from "@angular/core";

import { OverlaySpinnerService } from "../overlayspinner/overlaySpiner.service";
import { LocationService } from "../location/location.service";
import { Subscription } from "rxjs";
import { Paging } from "../../shared/paging";
import { ContentType, SortDirection, SnackBarMessageType, AnounceModalResult, LocationServiceStatus } from "../../shared/contentTypes";
import { PagingHelper } from "../../shared/pagingHelper";
import { SortOption } from "../../shared/models/sort.model";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { CoreLogService } from "../../services/log.service";
import { SnackBarService, snackBarMessageKey } from "../../services/snackBar.service";
import { Router, ActivatedRoute } from "@angular/router";
import { ScrollHelper } from "../../shared/scrollHelper";
import { IOSHelperService } from "../../services/IOSHelper.service";
import Utils from "../../shared/utils";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { WebShopService } from "../../services/webShop.service";
import { WebShopMode } from "../../services/IWebShopService";
import { LocationWebshopViewModel } from "../../shared/models/location.model";
import { CoreLanguageService } from "../../services/language.service";
import { WarningdialogComponent } from "../../modalDialogs/warningDialog/warningDialog.component";
import { ExternalLinksSettingsService } from "../../services/ExternalLinksSettings.service";
import { ConfirmationModalDialogComponent } from "../../modalDialogs/confirmationModalDialog/confirmationModalDialog.component";
import { CoreCOMService } from "../../services/com.service";
import { AnnounceDialogComponent } from "../../modalDialogs/announceDialog/announceDialog.component";
import { Location } from "@angular/common";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";
import { RouterHelperService } from "../../services/routerHelper.service";
import { Coordinates } from "../../services/com/comEnvironmentGeolocationCoordinates";
import { WebshopSettingsDataModel2 } from "../../shared/models";
import { DeliveryAreaService } from "../../services/DeliveryArea.service";
import { Coordinates as GeocodeCoordinates } from "../../shared/models/geocoding.model";
import { AccessibilityWebShopService } from "../../services/accessibilityWebShop.service";
import { TrackingManager } from "../../services/tracking/tracking-manager";
import { LocalKeys, StorageHive } from "../../services/valueStorage.service";
import { DeviceLocationService } from "../../services/deviceLocation.service";

@Component({
  selector: "ya-menulocation",
  templateUrl: "./menuLocation.component.html",
  styleUrls: ["./menuLocation.component.scss"],
  providers: [LocationService, OverlaySpinnerService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuLocationComponent implements OnInit, OnDestroy, AfterViewInit {
  /**
 * This function filters the locationList base on the zipCode in the SearchBox at the top of the page.
 * @param searchKey used for filtering the data. Location zip will be filtered by zipCode.
 * @result return a function that is used in paging Class to filter data.
 */
  private static locationDeliveryZipCodeFilterFunction(zipCode: string, city: string): ((item: LocationWebshopViewModel) => boolean) {
    return (location: LocationWebshopViewModel): boolean => {
      return !location.delivery_areas || location.delivery_areas.length === 0 || location.delivery_areas.some(deliveryArea => deliveryArea.zip === zipCode && (!deliveryArea.city || deliveryArea.city === city));
    };
  }

  private static filterLocationsByCoordinates(coordinates: GeocodeCoordinates, approximated: boolean, fallbackPostalCode: string, fallbackCity: string): ((location: LocationWebshopViewModel) => boolean) {
    return (location: LocationWebshopViewModel): boolean => {
      var isInDeliveryArea = false;

      if (coordinates && !approximated && location.delivery_areas_polygon_map && location.delivery_areas_polygon_map.length > 0) {
        const polygoneMapIndexWithCoordinates = location.delivery_areas_polygon_map.findIndex((deliveryAreaPolygonMap) => {
          return DeliveryAreaService.IsInArea(coordinates, deliveryAreaPolygonMap);
        });
        isInDeliveryArea = polygoneMapIndexWithCoordinates != -1;
      } else {
        isInDeliveryArea = MenuLocationComponent.locationDeliveryZipCodeFilterFunction(fallbackPostalCode, fallbackCity)(location);
      }

      return isInDeliveryArea;
    };
  }

  private static locationSearchFilterFunction(searchKey: string): ((item: LocationWebshopViewModel) => boolean) {
    return (location: LocationWebshopViewModel): boolean => {
      return (location.label.toLowerCase().includes(searchKey.toLowerCase())
        || location.street.toLowerCase().includes(searchKey.toLowerCase())
        || location.location.toLowerCase().includes(searchKey.toLowerCase())
        || location.zip.toLowerCase().includes(searchKey.toLowerCase())
      );
    };
  }

  //private static locationCityFilterFunction(city: string): ((item: LocationWebshopViewModel) => boolean) {
  //  return (location: LocationWebshopViewModel): boolean => {
  //    return !location.delivery_areas || location.delivery_areas.length === 0 || location.delivery_areas.some(s => s.city === city);
  //  };
  //}

  public serviceOpenTimeTitle = "phGlobal_OpenTime";
  public WebShopMode = WebShopMode;
  public needCity: boolean = false;
  public hasData: boolean = true; // check if there is data for this page;
  public locationList: LocationWebshopViewModel[];
  public cityList: string[] = [];
  public selectedCity: string;
  public isSelectedCity: boolean;
  public paging: Paging<LocationWebshopViewModel>;
  public searchLocationKey: string;
  public selectedDeliveryAddress: string = "";
  public contentType = ContentType;
  public currentPostalCode = "";
  public autoPostalCode = false;
  // public locationTabIndex: number = 0;
  private pagingHelper: PagingHelper;
  private sortOption: SortOption[];
  private filterFunction: ((item: LocationWebshopViewModel) => boolean)[];

  private langSubscriber: Subscription;
  private infiniteScrollSubscriber: Subscription;
  private locationChangesSubscriber: Subscription;
  public webshopServiceId: number;
  private webshopLocationIDs: number[] = [];
  private useBrowserHistory: boolean = true;
  private webshopSettings: WebshopSettingsDataModel2;
  private coordinates: GeocodeCoordinates;

  public isSmallView: boolean = false;
  private _viewTypeSubscription: Subscription;

  // ViewChildren
  @ViewChild('locationcontainer') locationContainer: any;

  constructor(private locationService: LocationService
    , private _coreLanguageService: CoreLanguageService
    , private internationalisationService: InternationalisationService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _routerHelperService: RouterHelperService
    , private _activatedRoute: ActivatedRoute
    , private _snackBarService: SnackBarService
    , private _router: Router
    , private _location: Location
    , private _externalLinksSettingsService: ExternalLinksSettingsService
    , private _coreComService: CoreCOMService
    , private _overlaySpinnerService: OverlaySpinnerService
    , private _scrollHelper: ScrollHelper
    , private _iosHelperService: IOSHelperService
    , private _webShopService: WebShopService
    , private _mainnavService: MainnavService
    , private _bottomSheetHelperService: BottomSheetHelperService
    , private _accessibilityWebShopService: AccessibilityWebShopService
    , private _trackingManager: TrackingManager
    , private _deviceLocationService: DeviceLocationService) {
    this.isSmallView = this._mainnavService.viewType === ViewType.Small;
  }

  ngAfterViewInit(): void {
  }

  private setSearchInputFocus() {
    const me = this;
    if (me.webshopServiceId === WebShopMode.Delivery) {
      setTimeout(() => {
        document.getElementById("locationSearcInput").focus();
      }, 500);
    }
  }

  /**When small view is true, navigation back by swiping from left to right.*/
  public SwiperNavigateBack() {
    const me = this;
    if (me.isSmallView == true) {
      me.navigateBack();
    }
  }

  ngOnInit() {
    const me = this;
    me.locationList = [];
    me.pagingHelper = new PagingHelper();
    me.sortOption = [];
    me.searchLocationKey = ""; // binding searchkey to searchbox.
    me.selectedCity = "-1"; // city not selected
    me.filterFunction = [];
    me.setRouteData();
    me.setOpenTimeTitle();
    me._webShopService.getWebshopSettingsDataModel()
      .then(settings => {
        me.webshopSettings = settings;
      });

    me.langSubscriber = me.internationalisationService.localeChanged.subscribe(() => {
      me.PushChanges();
    });

    me.locationChangesSubscriber = me.locationService.ObserveChanges.subscribe((change) => {
      me.ReloadDataAndRender();
    });

    me.setInifiniteScrollSunscriber();

    me._viewTypeSubscription = me._mainnavService.observeViewTypeChanges.subscribe((viewType) => {
      me.onViewTypeChanges(viewType);
      me.PushChanges();
    });
    me.updateCurrentlyUsedAddress();
    me.ReloadDataAndRender();
  }

  private onViewTypeChanges(viewType: ViewType) {
    const me = this;
    me.isSmallView = (viewType === ViewType.Small);

    // TODO Find the root cause instead of fixing the symptoms
    // Swiper elements are not correctly sized initally in Wide View or after View Change => trigger resizing
    setTimeout(() => {
      // ! triggers all resize Subscriptions again: Not good!
      window.dispatchEvent(new Event("resize"));
    }, 1000);
  }

  private setOpenTimeTitle() {
    const me = this;
    switch (me.webshopServiceId) {
      case WebShopMode.Delivery:
        {
          me.serviceOpenTimeTitle = "phGlobal_Delivery_openTime";
          break;
        }
      case WebShopMode.TakeAway:
        {
          me.serviceOpenTimeTitle = "phGlobal_Pickup_openTime";
          break;
        }
      default: {
        me.serviceOpenTimeTitle = "phGlobal_OpenTime";
        break;
      }
    }
  }

  private get currentlyUsedAddress() {
    return this._webShopService.currentlyUsedAddress;
  }
  private get currentlyUsedZipcode() {
    return this._webShopService.currentlyUsedZipcode;
  }
  private get currentlyUsedCity() {
    return this._webShopService.currentlyUsedCity;
  }
  private get currentlyUsedGeoCoordinates() {
    return this._webShopService.currentlyUsedGeoCoordinates;
  }

  public async updateCurrentlyUsedAddress() {
    const me = this;
    let addressString = "";

    if (me.currentlyUsedAddress === "" || me.currentlyUsedZipcode === "" || me.currentlyUsedCity === "") {
      addressString = await me.setAddressFromStorage();
    } else {
      addressString = (`${me.currentlyUsedAddress}, ${me.currentlyUsedZipcode} ${me.currentlyUsedCity}`);
    }
    me.selectedDeliveryAddress = me._coreLanguageService.value("ph_menuLocation_Your_Current_Address").replace("{address}", addressString);
    me.PushChanges();
  }

  /**
   * Set the address from local storage if available
   */
  private async setAddressFromStorage(): Promise<string> {
    const { deliveryPostCode, deliveryCity, deliveryStreet, houseNumber } = await this.getAddressDataFromStorage();
    const hasAddress = [deliveryPostCode, deliveryCity, deliveryStreet, houseNumber].every(value => !Utils.IsNullOrEmpty(value));
    if (!hasAddress) {
      return "";
    }
    return `${deliveryStreet} ${houseNumber}, ${deliveryPostCode} ${deliveryCity}`;
  }

  private async getAddressDataFromStorage() {
    const me = this;
    const keys = [LocalKeys.deliveryPostCode, LocalKeys.deliveryCity, LocalKeys.deliveryStreet, LocalKeys.houseNumber];
    const [deliveryPostCode, deliveryCity, deliveryStreet, houseNumber] = await Promise.all(
      keys.map(key => me._coreComService.environment.valueStorage.get(StorageHive.Local, key))
    );
    return {
      deliveryPostCode,
      deliveryCity,
      deliveryStreet,
      houseNumber
    }
  }

  public get isOrderWithoutTimeSelection() {
    const me = this;
    const orderWithoutTimeSelection = me.webshopServiceId === WebShopMode.Webvoucher
      || me.webshopServiceId === WebShopMode.Viewing
      || me.webshopServiceId === WebShopMode.Retail
      || me.webshopServiceId === WebShopMode.Ticket;
    return orderWithoutTimeSelection;
  }

  private _hasRequiredAddressInput() {
    const me = this;
    return !Utils.IsNullOrEmpty(me.currentlyUsedZipcode)
      && !Utils.IsNullOrEmpty(me.currentlyUsedCity)
      && !Utils.IsNullOrEmpty(me.currentlyUsedAddress)
  }

  /**
* Set the title of the page by title Data in route data
* This data has been set in RouterHelperService by each navigation Enh Evnt
*/
  private setRouteData() {
    const me = this;
    me.webshopServiceId = me._activatedRoute.snapshot.data.serviceId;
    me.webshopLocationIDs = me._activatedRoute.snapshot.data["menuSettingData"].menuSettingLocationIds;

    const routeTargetData = me._activatedRoute.snapshot.data["routeTargetData"];

    if (routeTargetData) {
      // todo remove route coordinates and use webshopService
      me.coordinates = routeTargetData["coordinates"];

      if (!routeTargetData["useBrowserHistory"]) {
        me.useBrowserHistory = routeTargetData["useBrowserHistory"];
      }
    } else {
      // Coming back from _location.back() => useBrowserHistory = true -> Angular says use router but we do not do it (* ￣︿￣)
      if (me._webShopService.PolygonMapInformation && me._webShopService.PolygonMapInformation.Coordinates) {
        me.coordinates = me._webShopService.PolygonMapInformation.Coordinates;
      }
    }
  }

  // initialize the sorting for first time loading.
  private initializeSortAndFilterOption(calculateDistance: boolean) {
    const me = this;
    me.sortOption.push(me.pagingHelper.createSortOption("like", SortDirection.DESC));
    if (calculateDistance) {
      me.sortOption.push(me.pagingHelper.createSortOption("distance", SortDirection.ASC));
    }
    me.sortOption.push(me.pagingHelper.createSortOption("sort_nr", SortDirection.ASC));
  }

  // set subscriber for scrollbar and load data for next page when it is in the exact point.
  private setInifiniteScrollSunscriber() {
    const me = this;
    me.infiniteScrollSubscriber = me._scrollHelper.InfiniteScrollObserver().subscribe((loadNextPage) => {
      if (loadNextPage && !Utils.IsNull(me.paging)) {
        me.locationList.push(...me.paging.nextPage());
        me.PushChanges();
        me.setLocationsStyle();
      }
    });
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("MenuLocationComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  /**
 * Get Locations
 */
  private async ReloadDataAndRender(): Promise<void> {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    const locationServiceStatus = await me._deviceLocationService.getLocationServiceStatus();
    let coordinates: Coordinates = null;
    let currentCity = "";
    if (me.webshopServiceId === me.WebShopMode.Delivery) {
      if (me._hasRequiredAddressInput()) {
        me.currentPostalCode = me.currentlyUsedZipcode;
        currentCity = me.currentlyUsedCity;
        if (me.currentlyUsedGeoCoordinates) {
          coordinates = new Coordinates(true, me.currentlyUsedGeoCoordinates.Longitude, me.currentlyUsedGeoCoordinates.Latitude);
        }
      } else {
        coordinates = await me._deviceLocationService.getCurrentPosition();
        if (coordinates) {
          me.currentPostalCode = await me._deviceLocationService.getPostalCodeForCoordinates(coordinates);
        }
      }
    }
    me.locationService.GetWebshopLocationViewModel(me.webshopServiceId, me.webshopLocationIDs, locationServiceStatus, coordinates)
      .then(locations => {
        if (locations) {
          me.hasData = true;
          const DefaultPageSize = !me.isSmallView ? 200 : 4;
          let CurrentPage = 2;
          if (!Utils.IsNull(me.paging)) {
            CurrentPage = me.paging.CurrentPage;
          }
          if ((me.currentPostalCode && me.webshopServiceId === me.WebShopMode.Delivery)
            || ((coordinates || locationServiceStatus === LocationServiceStatus.BrowserMode || locationServiceStatus === LocationServiceStatus.NotAuthorized) && (me.webshopServiceId === me.WebShopMode.Webvoucher || me.webshopServiceId === me.WebShopMode.TakeAway))) {
            me.initializeSortAndFilterOption(true);
          } else {
            me.initializeSortAndFilterOption(false);
          }
          if (me.currentPostalCode) {
            me.autoPostalCode = true;
            me.paging = new Paging(locations, DefaultPageSize, me.sortOption, me.filterFunction);
            me.searchLocationFilter(null, me.currentPostalCode, currentCity);
          } else {
            me.paging = new Paging(locations, DefaultPageSize, me.sortOption, me.filterFunction);
            me.locationList = []; // clean up
            me.locationList.push(...me.paging.initLoad(CurrentPage));
          }
          me._overlaySpinnerService.HideLayoutSpinner();
          me.PushChanges();
          if (me.locationList.length === 0) {
            me.openAnnounceDialog();
          }
          me.animateItems();
          setTimeout(() => {
            me.setLocationsStyle();
            if (me.webshopServiceId !== me.WebShopMode.Delivery && me.webshopServiceId !== me.WebShopMode.OrderToTable && (locationServiceStatus === LocationServiceStatus.NotAuthorized || locationServiceStatus === LocationServiceStatus.BrowserMode)) {
              me.setlocationDistance()
            }
          }, 200);

        } else {
          me.hasData = false;
          me._overlaySpinnerService.HideLayoutSpinner();
          me.PushChanges();
        }
      })
      .catch(e => {
        me._coreLogService.error("MenuLocationComponent.ReloadDataAndRender", "GetLocationViewModel", e);
        me._overlaySpinnerService.HideLayoutSpinner();
        me._snackBarService.ShowErrorMessageFailed(67);
      });
  }
  /**
   * Calculate location distance to current location based on lat and long
   * @param locations locationviewmodel list
   */
  private setlocationDistance(): void {
    const me = this;

    if (me.webshopServiceId === me.WebShopMode.Delivery && me.webshopSettings.use_poly_map && me.coordinates) {
      me.calcDistanceForLocationsAndRerender(new Coordinates(true, me.coordinates.Longitude, me.coordinates.Latitude));
    } else {
      me._deviceLocationService.getCurrentPosition()
        // calcDistanceForLocationAndRerender accesses this,
        // however here the function is passed, so we must bind it to me
        .then(me.calcDistanceForLocationsAndRerender.bind(me))
        .catch(error => {
          me._coreLogService.error("MenuLocationComponent.setlocationDistance", "getCurrentPosition()", error);
        })
    }
  }

  private calcDistanceForLocationsAndRerender(coordinates: Coordinates) {
    const me = this;
    me.locationList.forEach(loc => {
      if (coordinates && loc.latitude > 0 && loc.longitude > 0) {
        loc.distance = +(Utils.getDistanceBetweenPoints(coordinates.latitude, coordinates.longitude, loc.latitude, loc.longitude).toFixed(1));
      } else {
        loc.distance = 1000000;// must be place at the end by sorting
      }
    });
    me.paging.setSorting(me.sortOption);
    me.locationList = []
    me.locationList = me.paging.initLoad();
    me.PushChanges();
    setTimeout(() => {
      me.setLocationsStyle();
    }, 200);
  }

  public currentLocationValue() {
    const me = this;
    return `${me._coreLanguageService.value("ph_menuLocation_Your_Current_Location")}${me.searchLocationKey}`;
  }

  public setPostalCodePlaceHolder() {
    const me = this;
    if (me.webshopServiceId === me.WebShopMode.Delivery) {
      return me._coreLanguageService.value("ph_menuLocation_Select_PostalCode");
    } else {
      return me._coreLanguageService.value("ph_menuLocation_Search");
    }
  }
  public get isColorsEnabled(): boolean {
    return this._accessibilityWebShopService.isAccessabiltyColorsEnabled();
  }
  public getListByCity(value: string) {
    const me = this;
    me.filterFunction = [];
    me.selectedCity = value;
    if (me.searchLocationKey.length > 0) {
      me.filterFunction.push(MenuLocationComponent.locationDeliveryZipCodeFilterFunction(me.searchLocationKey, value !== "-1" ? value : ""));
      me.paging.setFilter(me.filterFunction);
      me.locationList = []; // clean up
      me.locationList.push(...me.paging.initLoad());
      me.PushChanges();
      if (me.locationList.length === 0) {
        me._snackBarService.ShowMessage(snackBarMessageKey.locationNotFound, SnackBarMessageType.Warning);
      }
      me.animateItems();
    }
  }

  public setManualPostalcodeMode() {
    const me = this;
    me.searchLocationKey = "";
    me.autoPostalCode = false;
    me.setSearchInputFocus();
    me.searchLocationFilter(null, me.searchLocationKey, "");
  }

  public navigateToAddressQuery() {
    const me = this;
    me._router.navigate(["/orderAddressQuery"]);
  }

  private _navigateAndChangeLocation() {
    const me = this;
    if (me.webshopServiceId === me.WebShopMode.Delivery) {
      me.navigateToAddressQuery();
    } else {
      me.setManualPostalcodeMode();
    }
  }

  /**
   * This function filters LocationList when KeyUp Event of searchBox fired.
   * @param searchKey key for filtering Locationlist
   */
  public searchLocationFilter(event, searchKey: string, city: string): void {
    const me = this;
    if (event && event.keyCode === 13) {
      document.getElementById("locationSearcInput").blur();
      return;
    }

    me.filterFunction = [];
    me.searchLocationKey = me.webshopServiceId === me.WebShopMode.Delivery ? me._webShopService.currentlyUsedZipcode : searchKey;
    me.selectedCity = city ? city : "-1";
    me.isSelectedCity = me.selectedCity !== "-1";
    if (me.searchLocationKey.length > 0) {
      if (me.webshopServiceId === me.WebShopMode.Delivery) {
        me.filterFunction.push(MenuLocationComponent.filterLocationsByCoordinates(me.coordinates, false, me._webShopService.currentlyUsedZipcode, me._webShopService.currentlyUsedCity));
      } else {
        me.filterFunction.push(MenuLocationComponent.locationSearchFilterFunction(me.searchLocationKey));
      }
      me.paging.setFilter(me.filterFunction);
      me.locationList = []; // clean up
      me.locationList.push(...me.paging.initLoad());
      if (me.locationList.length === 0) {
        me.needCity = false;
        me.PushChanges();
      } else {
        if (me.webshopServiceId === me.WebShopMode.Delivery) {
          // Get all cities for available locations
          const deliveryCityList: string[] = [];
          me.locationList.forEach(location => {
            if (location.delivery_areas) {
              deliveryCityList.push(...location.delivery_areas.filter(d => d.zip === searchKey).map(m => m.city.trim()));
            }
          });
          // Filter duplicate locations
          me.cityList = [];
          deliveryCityList.forEach(loc => {
            if (loc != "" && !me.cityList.includes(loc)) {
              me.cityList.push(loc);
            }
          });

          // Show city selection if no city is selected at least 1 city selectable
          me.needCity = !me.isSelectedCity && me.cityList.length > 0;
          if (me.needCity) {
            // postal code has only one location and should be preselected
            const allLocationsRequireSameCity = me.cityList.length === 1 && // Only 1 City
              !deliveryCityList.some(city => city == "") && // No Location without specified City
              me.locationList.length === deliveryCityList.length; // No Locations that deliverys everywhere

            if (allLocationsRequireSameCity) {
              me.selectedCity = me.cityList.toString();
              me.isSelectedCity = true;
            }
          }
        }
        me.PushChanges();
        me.animateItems();
      }
    } else {
      me.paging.setFilter(me.filterFunction);
      me.locationList = []; // clean up
      me.locationList.push(...me.paging.initLoad());
      me.PushChanges();
      if (me.locationList.length === 0) {
        me._snackBarService.ShowMessage(snackBarMessageKey.locationNotFound, SnackBarMessageType.Warning);
      }
      me.animateItems();
    }
    setTimeout(() => {
      me.setLocationsStyle();
      // if (me.webshopServiceId !== me.WebShopMode.Delivery && me.webshopServiceId !== me.WebShopMode.OrderToTable && (locationServiceStatus === LocationServiceStatus.NotAuthorized || locationServiceStatus === LocationServiceStatus.BrowserMode)) {
      //   me.setlocationDistance()
      // }
    }, 200);
  }

  public removeSearchBox() {
    const me = this;
    me.searchLocationFilter(null, "", "");
  }

  public setWebView() {
    const me = this;
    me._iosHelperService.setWebviewAfterBlur();
  }

  public checkLocation(location: LocationWebshopViewModel) {
    const me = this;
    me._webShopService.openWarningResetBasketDialogIfNeed(location.hyp_cus_nr, me._webShopService.getServiceMode(), (agree) => {
      if (agree) {
        me.selectLocation(location);
        this.trackFindLocation(location);
      } /* else do nothing */
    });
  }

  private async setServiceModeIfNeeded() {
    const me = this;
    const serviceMode = me._webShopService.getServiceMode();
    if (serviceMode === null) {
      await me._webShopService.setServiceMode(me.webshopServiceId);
    }
  }

  private async selectLocation(location: LocationWebshopViewModel) {
    const me = this;
    if (me.webshopServiceId === me.WebShopMode.Delivery) {
      await me.selectLocationForDelivery(location);
    } else if (me.isOrderWithoutTimeSelection) {
      me.selectLocationWithoutTimeSelection(location);
    } else if (me.webshopServiceId === WebShopMode.OrderToTable) {
      await me.selectLocationForOrderToTable(location);
    } else {
      await me.selectLocationForTimeBasedOrder(location);
    }
  }

  private async selectLocationForDelivery(location: LocationWebshopViewModel): Promise<void> {
    const me = this;
    await me.setServiceModeIfNeeded();
    me.searchLocationKey = me._webShopService.currentlyUsedZipcode;
    if (me.resolveDeliveryArea(location)) {
      if (location.delivery_external_link) {
        me.handleExternalDeliveryLink(location);
      } else if (me.searchLocationKey) {
        const city = (me.selectedCity !== "-1") ? me.selectedCity : "";
        await me.initializeServiceTimeSelectionOptions(location, me.webshopServiceId, me.searchLocationKey, city, me.currentlyUsedAddress);
      }
    } else {
      me.warningBottomSheet();
    }
  }

  /** Precondition: canUsePolygonMap holds (use_poly_map + non-empty polygon map + coordinates)
   * — enforced by resolveDeliveryArea. */
  private resolvePolygonMapArea(location: LocationWebshopViewModel): boolean {
    const me = this;
    let deliveryFees = undefined;
    const cheapestDeliveryZoneForLocation = DeliveryAreaService.FindDeliveryZone(me.coordinates, location.delivery_areas_polygon_map);
    if (cheapestDeliveryZoneForLocation) {
      cheapestDeliveryZoneForLocation.DeliveryFees.sort((a, b) => a.ShoppingCartValue - b.ShoppingCartValue);
      deliveryFees = cheapestDeliveryZoneForLocation.DeliveryFees;
    }
    me._webShopService.PolygonMapInformation = {
      DeliveryFees: deliveryFees,
      Coordinates: me.coordinates
    };
    return cheapestDeliveryZoneForLocation != null;
  }

  private validateZipCityArea(location: LocationWebshopViewModel): boolean {
    const me = this;
    return me._webShopService.isDeliveryAddressValid(
      me.searchLocationKey,
      me._webShopService.currentlyUsedCity,
      me._webShopService.currentlyUsedAddress,
      "",
      location.delivery_areas
    );
  }

  private resolveDeliveryArea(location: LocationWebshopViewModel): boolean {
    const me = this;
    me._webShopService.PolygonMapInformation = null;
    const canUsePolygonMap =
      me.webshopSettings.use_poly_map &&
      location.delivery_areas_polygon_map &&
      location.delivery_areas_polygon_map.length > 0 &&
      me.coordinates;
    if (canUsePolygonMap) {
      return me.resolvePolygonMapArea(location);
    }
    return me.validateZipCityArea(location);
  }

  /** Fire-and-forget: intentionally not awaited — the caller returns before settings resolve. */
  private handleExternalDeliveryLink(location: LocationWebshopViewModel): void {
    const me = this;
    me._webShopService.getWebshopSettingsDataModel()
      .then(webShopSetting => {
        me.webshopSettings = webShopSetting;
        if (webShopSetting.information_text_when_leaving) {
          me._externalLinksSettingsService.GetExternalLinksSettings()
            .then(externalLink => {
              me.openConfirmationModal(externalLink, location.delivery_external_link);
            })
            .catch(e => {
              me._coreLogService.error("MenuLocationComponent.handleExternalDeliveryLink", "GetExternalLinksSettings", e);
            });
        } else {
          window.open(location.delivery_external_link, "_system");
        }
      });
  }

  private selectLocationWithoutTimeSelection(location: LocationWebshopViewModel): void {
    const me = this;
    me.navigateAfterLocationSet(location, "", "", "");
  }

  private async selectLocationForOrderToTable(location: LocationWebshopViewModel): Promise<void> {
    const me = this;
    me._webShopService.resetWebshopService();
    me.navigateAfterLocationSet(location, "", "", "");
  }

  private async selectLocationForTimeBasedOrder(location: LocationWebshopViewModel): Promise<void> {
    const me = this;
    await me.setServiceModeIfNeeded();
    await me.initializeServiceTimeSelectionOptions(location, me.webshopServiceId, "", "", "");
  }

  /** Initializes and returns a ServiceTimeSelectionOptions object.*/
  private async initializeServiceTimeSelectionOptions(location: LocationWebshopViewModel, serviceMode: WebShopMode, zipCode: string, city: string, address: string) {
    const me = this;
    await me._webShopService.initializeAndProcessServiceTime({
      serviceMode: serviceMode,
      location: location,
      zipCode: zipCode,
      city: city,
      address: address,
    });
  }

  private trackFindLocation(location: LocationWebshopViewModel): void {
    this._trackingManager.trackFindLocation(location);
  }

  private openConfirmationModal(response: any, targetUrl: string) {
    const me = this;
    const bottomSheetRef = me._bottomSheetHelperService.open(ConfirmationModalDialogComponent, {
      data: {
        title: "phExternalLinkModal_confirmation_Title",
        description: () => response.legalText,
        buttonText: "phExternalLinkModal_confirm_Button_Text"
      }
    });
    bottomSheetRef.afterDismissed().subscribe((result: boolean) => {
      if (result) {
        window.open(targetUrl, "_system");
      }
    });
  }

  private openAnnounceDialog() {
    const me = this;
    const usePolyMap = me.webshopSettings.use_poly_map && me.coordinates;
    const contentDialogue = usePolyMap ? "ph_menuLocation_Announce_Dialog_PolyMap_Content" : "ph_menuLocation_Announce_Dialog_Content";
    const firstBtn = usePolyMap ? "ph_menuLocation_Announce_Dialog_PolyMap_FirstBtn_Label" : "ph_menuLocation_Announce_Dialog_FirstBtn_Label";

    const warningDialog = me._bottomSheetHelperService.open(AnnounceDialogComponent, {
      data: {
        title: "ph_menuLocation_Announce_Dialog_Title"
        , content: contentDialogue
        , firstBtnLabel: firstBtn
        , secondBtnLabel: "ph_menuLocation_Announce_Dialog_SecondBtn_Label"
      },
      panelClass: "mat-bottom-sheet-container--full-height"
    });
    warningDialog.afterDismissed().subscribe((result: AnounceModalResult) => {
      if (result === AnounceModalResult.FirstButton) {
        me._navigateAndChangeLocation();
      } else if (result === AnounceModalResult.SecondButton) {
        me._router.navigate(["/menuservice"]);
      } else {
        // nothing
      }
    });
  }

  private navigateAfterLocationSet(location: LocationWebshopViewModel, zipCode: string, city: string, address: string): void {
    const me = this;
    me._webShopService.setServiceLocationInfo(location, zipCode, city, address).then(() => {
      if (me.webshopServiceId === WebShopMode.Webvoucher) {
        me._webShopService.tryAndRouteToSingleVariableWebvoucher();
      } else if (me.webshopServiceId === WebShopMode.OrderToTable) {
        me._router.navigate(["/menuservice"]);
      } else {
        me._router.navigate(["/menugroup"]);
      }
    });
  }

  private warningBottomSheet() {
    const me = this;
    const warningButtomSheet = me._bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        title: "ph_menuLocation_ZipCode_Warning_Title"
        , content: "ph_menuLocation_ZipCode_Warning_Content"
        , btnLabel: "ph_menuLocation_ZipCode_Warning_BtnLabel"
        , option: "ph_menuLocation_ZipCode_Warning_Option"
      },
      panelClass: "mat-bottom-sheet-container--full-height"
    });
    warningButtomSheet.afterDismissed().subscribe((result) => {
      if (result) {
        me.setSearchInputFocus();
      }
    });
  }

  public navigateBack() {
    const me = this;
    if (me.useBrowserHistory) {
      me._location.back();
    } else {
      if (me.webshopServiceId === WebShopMode.Webvoucher && me.webshopSettings.is_vouchercharge_enabled) {
        me._routerHelperService.setRouteTargetDataByKey("useBrowserHistory", me.useBrowserHistory);
        me._router.navigate(["/vouchercredit"], { replaceUrl: true });
      } else {
        me._router.navigate(["/menuservice"], { replaceUrl: true });
      }
    }
  }

  ngOnDestroy(): void {
    const me = this;
    if (me.langSubscriber) {
      me.langSubscriber.unsubscribe();
    }
    if (me.infiniteScrollSubscriber) {
      me.infiniteScrollSubscriber.unsubscribe();
    }
    if (me.locationChangesSubscriber) {
      me.locationChangesSubscriber.unsubscribe();
    }
    if (me._viewTypeSubscription) {
      me._viewTypeSubscription.unsubscribe();
    }
  }

  // set style for location list for animation effect
  private setLocationsStyle() {
    const me = this;
    const vh: number = +document.documentElement.style.getPropertyValue("--vh").replace("px", "");
    const itemList: HTMLElement[] = Array.from(me.locationContainer.nativeElement.getElementsByClassName("location-item"));
    let topOffset = 0;
    const marginTop = 16;
    itemList.forEach(element => {
      element.style.position = "absolute";
      element.style.top = topOffset + "px";
      topOffset += element.offsetHeight + marginTop;
    });
    me.locationContainer.nativeElement.style.height = topOffset + "px";
  }

  private animateItems() {
    const me = this;
    if (me.locationContainer) {
      const Items = me.locationContainer.nativeElement
        .getElementsByClassName("ya-content-item");
      setTimeout(() => {
        for (let i = 0; i < Items.length; i++) {
          const element = Items[i];
          setTimeout(() => {
            element.classList.add("item-animated");
          }, i * 100)
        }
      }, 100)
    }
  }
}
